import React from "react";
import styled from "styled-components/macro";

type IProps = {
  children: JSX.Element;
};
const GrayTextBox = ({ children }: IProps) => {
  return <Wrapper>{children}</Wrapper>;
};

export default GrayTextBox;

const Wrapper = styled.div`
  padding: 24px;
  border: 1px solid #d1d1d1;
  background-color: ${({ theme }) => theme.colors.lighterGray};
  margin-bottom: 64px;
  page-break-inside: avoid;
`;
